<template>
    <div>
        <div v-if="base === 'create'" class="flex flex-row justify-content-between class-for-mobile-view" :class="[(!isGenericFormRequest ? 'px-4' : '')]">
            <div class="row" style="width: 104%;">
                <div v-for="(field, index) in custom_fields" v-if="field.is_foundation_custom_id ? isContactResidential : true" :class="[(!isGenericFormRequest ? 'w-50' : 'w-100')]">
                    <div v-if="field.type === 2" class="mb-3 col-md-12 viewForMobile">
                        <label class="text-grey-darkest text-sm"
                               :class="[((customFieldErrors && customFieldErrors.errors && customFieldErrors.errors[field.label_value] && customFieldErrors.errors[field.label_value].length > 0) ? 'text-red' : '')]">
                            {{field.label_value}}
                        </label>
                        <input @focusout="customFieldPop()" type="text" v-model="form[field.id]"
                               :class="[(form.errors.has(form[field.id]) ? 'border-red' : ''),
                               ((field.is_foundation_custom_id && field.is_foundation_id_auto_generated && foundationAutoGeneratedAccess) ? 'bg-grey' : 'bg-white'),
                               ((customFieldErrors && customFieldErrors.errors && customFieldErrors.errors[field.label_value] && customFieldErrors.errors[field.label_value].length > 0) ? 'border-red' : '')]"
                               class="leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                               :disabled="isFoundationAutoGeneratedCustomerNoFieldDisabled(field)">
                        <div class="text-red" v-if="form.errors.has(form[field.id])">
                            {{ form.errors.get(form[field.id]) }}
                        </div>
                        <div class="text-red" v-else-if="customFieldErrors && customFieldErrors.errors && customFieldErrors.errors[field.label_value] && customFieldErrors.errors[field.label_value].length > 0">
                            {{ customFieldErrors.errors[field.label_value][0] }}
                        </div>
                    </div>
                    <div v-if="field.type === 1 || field.type === 3" class="mb-3 col-md-12 viewForMobile">
                        <label class="text-grey-darkest text-sm"
                               :class="[((customFieldErrors && customFieldErrors.errors && customFieldErrors.errors[field.label_value] && customFieldErrors.errors[field.label_value].length > 0) ? 'text-red' : '')]">
                            {{field.label_value}}
                        </label>
                        <multiselect
                            @focusout="customFieldPop()"
                            class="cursor-pointer"
                            :class="[((customFieldErrors && customFieldErrors.errors && customFieldErrors.errors[field.label_value] && customFieldErrors.errors[field.label_value].length > 0) ? 'border-red-multiselect' : '')]"
                            :options="field.options"
                            v-model="form[field.id]"
                            :show-labels="false"
                            @input="resetValidationErrors(field)"
                            track-by="id"
                            label="name"
                            value="id">
                        </multiselect>
                        <div class="text-red" v-if="form.errors.has(form[field.id])">
                            {{ form.errors.get(form[field.id]) }}
                        </div>
                        <div class="text-red" v-else-if="customFieldErrors && customFieldErrors.errors && customFieldErrors.errors[field.label_value] && customFieldErrors.errors[field.label_value].length > 0">
                            {{ customFieldErrors.errors[field.label_value][0] }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="base === 'edit'" class="flex flex-row px-4 mb-3 w-full" v-for="(field, index) in custom_fields" style="padding-right: 0 !important;">
            <label v-if="field.type === 2" class="text-grey-darkest text-sm" style="width: 27%">{{field.label_value}}</label>
            <div v-if="field.type === 2" style="width: 63%">
                <div class="flex">
                    <input @focusout="customFieldPop();pushToSpectrum(field)" type="text" v-model="form[field.id]"
                           :class="[
                           (
                            (form.errors.has(form[field.id]) ? 'border-red' : ''),
                            (field.is_foundation_custom_id && field.is_foundation_id_auto_generated && foundationAutoGeneratedAccess) ||
                            (spectrumCustomerCodeCustomFieldId && spectrumCustomerCodeCustomFieldId == field.id && !editingSpectrumCustomField) ||
                            (isSage300ContactCodeCustomField(field.id) ||
                            isSage300CustomerCodeCustomField(field.id)) ||
							(foundationAccess && foundationCustomerCodeCustomFieldId == field.id &&  !editingSpectrumCustomField)
                           ) ? 'bg-grey' : 'bg-white']"
                           class="leading-normal appearance-none border-1 rounded text-grey-darkest focus:outline-none ml-1"
                           style="width: 100%;padding: 5px 0 5px 10px; font-size: 14px"
                           :disabled="isFoundationAutoGeneratedCustomerNoFieldDisabled(field) || (spectrumCustomerCodeCustomFieldId && spectrumCustomerCodeCustomFieldId == field.id && !editingSpectrumCustomField) || isSage300ContactCodeCustomField(field.id) || (foundationAccess && foundationCustomerCodeCustomFieldId == field.id && !editingSpectrumCustomField) || isSage300CustomerCodeCustomField(field.id)">
                    <span v-if="(spectrumCustomerCodeCustomFieldId && spectrumCustomerCodeCustomFieldId == field.id && !editingSpectrumCustomField) || isSage300ContactCodeCustomField(field.id) || (foundationAccess && foundationCustomerCodeCustomFieldId == field.id && !editingSpectrumCustomField) || isSage300CustomerCodeCustomField(field.id)" class="ml-2 cursor-pointer" @click.prevent="selectedCustomFieldId = field.id; openModal('spectrumCustomerCodeChangeConfirmModal')">
                        <i class="fa fa-pencil"></i>
                    </span>
                </div>
                <div class="text-red" v-if="form.errors.has(form[field.id])">
                    {{ form.errors.get(form[field.id]) }}
                </div>
            </div>
            <label v-if="field.type === 1 || field.type === 3" class="text-grey-darkest text-sm" style="width: 28%">{{field.label_value}}</label>
            <div v-if="field.type === 1 || field.type === 3" style="width: 63%">
                <multiselect
                    @focusout="customFieldPop()"
                    class="cursor-pointer"
                    :options="field.options"
                    v-model="form[field.id]"
                    :show-labels="false"
                    @input="form.errors.clear(form[field.id])"
                    track-by="id"
                    label="name"
                    value="id">
                </multiselect>
                <div class="text-red" v-if="form.errors.has(form[field.id])">
                    {{ form.errors.get(form[field.id]) }}
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="spectrumCustomerCodeChangeConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 v-if="isSage300ContactCodeField" class="modal-title text-teal font-medium">Are you sure you want to edit the {{ currentErpName() }} Contact #</h5>
                        <h5 v-else class="modal-title text-teal font-medium">Are you sure you want to edit the {{ currentErpName() }} Customer #</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p v-if="isSage300ContactCodeField">Changing the Contact # will create a new contact on {{ currentErpName() }} or link this conact with another contact on {{ currentErpName() }} that matches the new contact # entered</p>
                        <p v-else>Changing the Customer # will create a new customer on {{ currentErpName() }} or link this conact with another Customer on {{ currentErpName() }} that matches the new Customer # entered</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeModal('spectrumCustomerCodeChangeConfirmModal')">Cancel</button>
                        <button type="button" class="btn btn-danger" @click.prevent="editSpectrumCustomField()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal" tabindex="-1" role="dialog" id="wrongMappingDirection" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">Error: The direction is not correct.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="text-danger">Error: The mapping direction is from {{ currentErpName() }} to Followup. Try changing the direction in settings.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeModal('wrongMappingDirection')">Close</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Form from "../../../utils/form";
import Multiselect from 'vue-multiselect';

export default {
    props: ['contact', 'agaveErp', 'base', 'foundationCustomerAccess', 'foundationAutoGeneratedAccess', 'customFieldErrors', 'isGenericFormRequest', 'spectrumCustomerCodeCustomFieldId', 'spectrumAccess', 'spectrumContactMapping','foundationCustomerCodeCustomFieldId','foundationAccess'],
    components: {Multiselect},
    mounted() {
        console.log('foundationCustomerCodeCustomFieldId', this.foundationCustomerCodeCustomFieldId);
        console.log('foundationCustomerAccess', this.foundationAccess);
    },
    data() {
        return {
            custom_fields: {},
            form: null,
            contact_id : this.contact_id ? this.contact_id : '',
            foundationCustomIdField: null,
            isContactResidential: false,
            editingSpectrumCustomField: false,
            editingFoundationCustomField:false,
            oldCustomFieldValues: null,
			selectedCustomFieldId: null,
        };
    },
    computed: {
        sage300Access() {
            return !!(this.agaveErp && this.agaveErp.third_party_name == 'sage-300-cre');
        },
        isSage300ContactCodeField() {
            return !!(this.currentErpName() == 'Sage 300' && this.isSage300ContactCodeCustomField(this.selectedCustomFieldId))
        },
    },
    watch: {
        'form': {
            handler(newValue, oldValue) {
                this.validateFoundationCustomerNumber(newValue);
            },
            deep: true
        }
    },
    created() {
        this.fetchCustomFields();
    },
    methods: {
        customFieldPop(){
            this.$emit('change-custom-field', true);
        },
        fetchCustomFields(){
            let self = this;
            let prams = '';
            if (typeof self.contact !== 'undefined')
            {
                prams = `?contact_id=${self.contact.id}&contact=true`;
            }else {
                prams = `?contact=true`;
            }
            axios.get(route('api.contact-custom-field.index') + prams).then(({data}) => {
                self.custom_fields = data.data;

                // Add Empty Object in Array for Dropdown Custom Fields
                self.custom_fields.forEach(function(field) {
                    if(field.options.length > 0) {
                        let emptyObject = {
                            id: null,
                            name: null,
                        };
                        field.options.push(emptyObject);
                    }
                });

                let custom = [];
                for (let field in self.custom_fields) {
                    custom[self.custom_fields[field].id] = '';
                    if(self.custom_fields[field].is_foundation_custom_id) {
                        self.foundationCustomIdField = self.custom_fields[field];
                    }
                }
                custom['contact_id'] = '';
                custom['request_type'] = this.base;

                self.form = new Form(custom);
                if (self.contact) {
                    self.fetchCustomValues();
                }
            });
        },

        fetchCustomValues(){
            let self = this;
            axios.get(route('api.contact-custom-field-value.index') + `?contact_id=${this.contact.id}`).then(({data}) => {
                this.oldCustomFieldValues = data.data
                data.data.forEach(field => {
                    if(field.selected_user_custom_field_value) {
                        let userFieldObj = {
                            id: field.selected_user_custom_field_value.id,
                            name: field.selected_user_custom_field_value.name,
                        };
                        self.form[field.contact_custom_field_id] = userFieldObj;
                    }
                    else if(field.selected_dropdown_custom_field_value) {
                        let dropdownFieldObj = {
                            id: field.selected_dropdown_custom_field_value.id,
                            name: field.selected_dropdown_custom_field_value.name,
                        };
                        self.form[field.contact_custom_field_id] = dropdownFieldObj;
                    }
                    else {
                        self.form[field.contact_custom_field_id] = field.value;
                    }
                });
            });
        },

        submit(contact_id, foundationCustomerNo = null){
            let self = this;
            this.form.contact_id = contact_id;
            if(foundationCustomerNo) {
                Object.keys(self.form).forEach((key) => {
                    if(self.foundationCustomIdField && self.foundationCustomIdField.hasOwnProperty('id') && key == self.foundationCustomIdField.id) {
                        self.form[key] = foundationCustomerNo;
                    }
                });
            }
            this.form.post(route('api.contact-custom-field-value.store')).then((data) => {
                $('#saveContactActivityButton').attr("disabled", false);
            });
        },
        isFoundationAutoGeneratedCustomerNoFieldDisabled(field) {
            return !!(field.is_foundation_custom_id && field.is_foundation_id_auto_generated && this.foundationAutoGeneratedAccess);
        },
        validateFoundationCustomerNumber(customFieldForm) {
            let self = this;
            Object.keys(customFieldForm).forEach((key) => {
                if(self.foundationCustomIdField && self.foundationCustomIdField.hasOwnProperty('id') && key == self.foundationCustomIdField.id) {
                    if((self.form[key]).length > 10) {
                        self.form[key] = customFieldForm[key].slice(0, 10);
                        self.getToast(2000).fire({
                            type: 'error',
                            title: 'Customer ID cannot exceed 10 characters'
                        });
                    }
                }
            });
        },
        resetValidationErrors(field) {
            this.form.errors.clear(this.form[field.id]);
            if(field && this.customFieldErrors && this.customFieldErrors.errors && this.customFieldErrors.errors[field.label_value]) {
                delete this.customFieldErrors.errors[field.label_value];
            }
        },
        resetForm() {
            let self = this;
            let formKeyArray = ['originalData', 'contact_id', 'request_type', 'errors'];
            Object.keys(self.form).forEach((key) => {
                if(!formKeyArray.includes(self.form[key])) {
                    self.form[key] = "";
                }
            });
        },
        openModal(modalId) {
            $('#'+modalId).modal('show');
        },
        closeModal(modalId) {
            $('#'+modalId).modal('hide');
        },
        pushToSpectrum(field){
            this.editingSpectrumCustomField = false;
            this.editingFoundationCustomField = false;
            if(this.form[field.id] && (this.spectrumAccess || this.sage300Access  || this.foundationAccess)){
                const existingFieldValue = this.oldCustomFieldValues ? this.oldCustomFieldValues.find(item => item.contact_custom_field_id == field.id) : null;
                if((this.form[field.id] && !existingFieldValue) || (this.form[field.id] !== existingFieldValue.value)){
                    if(this.sage300Access && this.getSafe(() => this.agaveErp.contact_field.direction) !== 'one-way-followup'){
                        this.$parent.$refs.Sage300Contact.pushContactToAgave();    //calling sage300 contact component method
                    }else if(this.spectrumContactMapping && this.spectrumContactMapping.direction !== 'one-way-followup'){
                        this.$emit('spectrum-customer-code-changed', {customerCode: this.form[field.id]});
                    }else if(this.foundationAccess && this.getSafe(() => this.agaveErp.contact_field.direction) !== 'one-way-followup'){
                        this.$parent.$refs.foundationContactComponent.pushContactToAgave(this.form[field.id]);    //
                    }else {
                        this.openModal('wrongMappingDirection');
                    }
                }
            }
        },
        editSpectrumCustomField(){
            this.editingSpectrumCustomField = !this.editingSpectrumCustomField;
            this.editingFoundationCustomField = !this.editingFoundationCustomField;
            this.closeModal('spectrumCustomerCodeChangeConfirmModal');
        },
        isSage300ContactCodeCustomField(field_id) {
            let customNumberFieldId = this.getSafe(() => this.agaveErp.contact_field.custom_contact_field.follow_up_field);
            return  !!(this.contact.is_contact_residential && this.sage300Access && !this.editingSpectrumCustomField && customNumberFieldId && customNumberFieldId == field_id)
        },
        isSage300CustomerCodeCustomField(field_id) {
            let customNumberFieldId = this.getSafe(() => this.agaveErp.contact_field.custom_customer_field.follow_up_field);
            return  !!(this.contact.is_contact_residential && this.sage300Access && !this.editingSpectrumCustomField && customNumberFieldId && customNumberFieldId == field_id)
        },
        currentErpName() {
            return this.spectrumAccess ? 'Spectrum' : (this.sage300Access ? 'Sage 300': '');
        },
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
@media only screen and (max-width: 768px) {
    .class-for-mobile-view .flex,
    .class-for-mobile-view .flex-row
    {
    display: inline-block !important;
    width: 100%;
    }

    .class-for-mobile-view .w-1\/5{
    float: right !important;
    width: 11% !important;
    display: inline-block !important;
    margin-top: 7%;
    }

    .class-for-mobile-view .w-4\/5{
    float: left !important;
    width: 88% !important;
    display: inline-block !important;
    }

    .class-for-mobile-view .viewForMobile{
    margin: 0 !important;
    margin-top: 15px !important;
    }

    .class-for-mobile-view .w-50{
        margin: 0 !important;
        margin-top: 2px !important;
        width: 100% !important;
    }
}
</style>
